/**
 * Mock 模块：heart_voyage_invite_handle
 * @see mockMd/heart_voyage_invite_handle.md
 */
import type {InviteHandleData} from '../types'

/** @see mockMd/heart_voyage_invite_handle.md · action=1 同意 */
export const HeartVoyageInviteHandleMock: InviteHandleData = {
  err_msg: '',
  pair_key: '10001:10002',
}

/** @see mockMd/heart_voyage_invite_handle.md · action=2 拒绝 */
export const HeartVoyageInviteHandleDeclineMock: InviteHandleData = {
  err_msg: '',
  pair_key: '',
}
